import type {DependencyList, ReactElement} from 'react';
import {useEffect} from 'react';
import {updatePanelPropsForModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {useModalData} from '@Components/modal/hooks/useModalData';

export const useUpdateMoreOptionsModal = (updatedContent: ReactElement<any>, dependencyArray: DependencyList, panelIdOpenedInModal?: string): void => {
  const modalData = useModalData(MODALS_IDS.MORE_OPTIONS_MODAL);

  const panelInModal = useAppSelector((state) => {
    if (!panelIdOpenedInModal) {
      return null;
    }

    return state.panels.panelHashmap[panelIdOpenedInModal] ?? null;
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!modalData) {
      return;
    }

    if (panelIdOpenedInModal && panelInModal === null) {
      return;
    }

    dispatch(
      updatePanelPropsForModal({
        modalId: MODALS_IDS.MORE_OPTIONS_MODAL,
        panelProps: {
          ...modalData.panelProps,
          content: updatedContent,
        },
      })
    );
  }, [...dependencyArray]);
};
